import { Link } from 'react-router-dom';
import { Fil } from './partages';
import { REGLAGES } from '../data/mock-data';
import { eurSansCentimes, pct } from '../data/repository';

/**
 * MENTIONS LÉGALES & CGV — la page que personne ne lit, sauf le jour où l'on en a
 * besoin. Elle reprend **les mêmes réglages** que la boutique : seuils d'arrhes,
 * tolérance de poids, délai RGPD. Un chiffre écrit ici ne peut donc pas contredire
 * le chiffre affiché au panier.
 *
 * Textes de démonstration ; le client les fera valider par son avocat (voir registre
 * des points à valider, entrée « CGV par un avocat »).
 */
export function Mentions() {
  const a = REGLAGES.arrhes;

  return (
    <main id="contenu" className="mx-auto max-w-[820px] px-5 py-8 sm:px-6">
      <Fil fils={[{ libelle: 'Mentions légales' }]} />

      <h1 className="text-balance text-[clamp(1.9rem,4.4vw,2.8rem)]">Mentions légales & conditions de vente</h1>
      <p className="mt-3 text-[0.9375rem] leading-relaxed text-muted">
        Dernière mise à jour : octobre 2026. Ces textes s’appliquent à la vitrine en ligne et
        aux commandes qui y sont passées. [À valider par le client — relecture par un avocat.]
      </p>

      <Section id="mentions" titre="Éditeur du site">
        <dl className="space-y-2">
          <Ligne t="Raison sociale">Maison Duval — SAS au capital de [À valider] €</Ligne>
          <Ligne t="Siège">17 rue d’Argenteuil, 95120 Sannois</Ligne>
          <Ligne t="SIRET">[À valider] — RCS Pontoise</Ligne>
          <Ligne t="TVA">Numéro intracommunautaire [À valider]</Ligne>
          <Ligne t="Téléphone">{REGLAGES.marque.telephone}</Ligne>
          <Ligne t="E-mail">{REGLAGES.marque.email}</Ligne>
          <Ligne t="Directeur de la publication">Michel Duval, gérant</Ligne>
          <Ligne t="Hébergement">[À valider — hébergeur et adresse]</Ligne>
        </dl>
      </Section>

      <Section id="cgv" titre="Conditions générales de vente">
        <h3 className="mt-6 font-display text-xl">Prix et poids</h3>
        <p>
          Les prix sont indiqués en euros, toutes taxes comprises (TVA {pct(REGLAGES.tva.alimentaire)} % sur les
          viandes et préparations, {pct(REGLAGES.tva.accessoire)} % sur les autres produits). La viande est vendue
          découpée à la demande : le poids et le montant affichés à la commande sont des estimations.
          Le prix définitif est celui du poids réel, dans une tolérance de ±{REGLAGES.poids.tolerancePct} %.
          Au-delà, la Maison absorbe l’écart.
        </p>

        <h3 className="mt-6 font-display text-xl">Arrhes</h3>
        <p>
          Les arrhes réservent la pièce : la Maison l’achète et la prépare pour le créneau choisi.
          Aucune arrhes n’est demandée en dessous de {eurSansCentimes(a.seuilLibre)}. Entre{' '}
          {eurSansCentimes(a.seuilLibre)} et {eurSansCentimes(a.seuilHaut)}, elles représentent{' '}
          {a.pctStandard} % du montant, avec la possibilité de tout régler au comptoir.
          Au-delà de {eurSansCentimes(a.seuilHaut)}, et pour les pièces préparées sur mesure,
          elles représentent {a.pctMesure} %. En cas d’annulation par le client moins de
          quarante-huit heures avant le créneau, les arrhes restent acquises à la Maison ;
          si la Maison ne peut pas honorer la commande, elles sont remboursées intégralement.
          {a.livraisonIntegrale ? ' La livraison réfrigérée est réglée intégralement en ligne.' : ''}
        </p>

        <h3 className="mt-6 font-display text-xl">Retrait, livraison et rétractation</h3>
        <p>
          Le retrait s’effectue au comptoir choisi, sur le créneau réservé. La livraison est assurée
          en colis isotherme maintenu à {REGLAGES.livraison.temperature}, sous {REGLAGES.livraison.delaiMinH} à{' '}
          {REGLAGES.livraison.delaiMaxH} heures ouvrées, offerte dès{' '}
          {eurSansCentimes(REGLAGES.livraison.seuilGratuite)} d’achat. Conformément à l’article
          L221-28 du Code de la consommation, le droit de rétractation ne s’applique pas aux denrées
          périssables ; en cas de rupture de la chaîne du froid constatée à la réception, le client
          dispose de {REGLAGES.livraison.reclamationFroidH} heures pour le signaler — remplacement ou
          remboursement, au choix du client.
        </p>

        <h3 className="mt-6 font-display text-xl">Réclamations et médiation</h3>
        <p>
          Une réclamation se fait d’abord au comptoir ou par téléphone. À défaut d’accord, le client
          peut saisir gratuitement le médiateur de la consommation compétent : [À valider — nom et
          coordonnées du médiateur].
        </p>
      </Section>

      <Section id="rgpd" titre="Données personnelles">
        <p>
          Les données collectées (identité, coordonnées, historique de commandes) servent uniquement
          à préparer, livrer et suivre les commandes, et à envoyer les messages que le client a
          demandés. Elles ne sont ni vendues ni cédées. La suppression du compte et de l’historique
          intervient {REGLAGES.rgpd.suppressionJours} jours après la demande, sauf commande en cours.
        </p>
        <p className="mt-3">
          Le client dispose d’un droit d’accès, de rectification, d’effacement et de portabilité,
          exerçable à l’adresse {REGLAGES.marque.email}. Une réclamation peut être adressée à la CNIL.
        </p>
      </Section>

      <Section id="cookies" titre="Cookies">
        <p>
          La vitrine n’utilise aucun cookie publicitaire ni traceur tiers. Seuls sont conservés dans
          le navigateur le panier en cours et les préférences d’affichage, sur l’appareil du client.
          Aucun consentement n’est donc requis ; ce choix sera réexaminé si un outil de mesure
          d’audience est ajouté.
        </p>
      </Section>

      <Section id="accessibilite" titre="Accessibilité">
        <p>
          La vitrine vise le niveau AA des règles WCAG 2.2 : contrastes vérifiés, navigation au
          clavier, libellés de formulaires explicites, respect de la préférence « mouvement réduit ».
          Un défaut constaté peut être signalé à {REGLAGES.marque.email} — il est traité comme un
          défaut de fabrication.
        </p>
      </Section>

      <p className="mt-10 border-t border-linen-deep pt-6 text-sm text-muted">
        Une question sur une commande ? <Link to="/livraison-et-retrait" className="font-semibold text-ink underline underline-offset-4">Livraison & retrait</Link>{' '}
        ou <Link to="/mon-compte" className="font-semibold text-ink underline underline-offset-4">votre espace client</Link>.
      </p>
    </main>
  );
}

function Section({ id, titre, children }: { id: string; titre: string; children: React.ReactNode }) {
  return (
    <section id={id} className="mt-10 scroll-mt-28">
      <h2 className="font-display text-2xl">{titre}</h2>
      <div className="mt-3 space-y-3 text-[0.9375rem] leading-relaxed text-ink-soft">{children}</div>
    </section>
  );
}

function Ligne({ t, children }: { t: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1 border-b border-linen-deep/60 pb-2 sm:flex-row sm:gap-6">
      <dt className="w-56 shrink-0 text-sm text-muted">{t}</dt>
      <dd className="text-[0.9375rem]">{children}</dd>
    </div>
  );
}
